module.exports = "#version 300 es\r\n\r\n\r\nin vec4 vs_Pos;             // The array of vertex positions passed to the shader\r\n\r\nout vec4 fs_Pos;\r\n\r\n\r\nvoid main()\r\n{\r\n    fs_Pos = vs_Pos;\r\n    gl_Position = vs_Pos;\r\n    gl_Position.z = 1.0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-vert.glsl
// module id = 71
// module chunks = 0